<template>
  <div class="flex flex-col items-center justify-center py-16 px-4 text-center animate-fade-in-up">
    <!-- Icon Container with subtle background and glow -->
    <div v-if="showIcon" class="relative mb-6 group">
      <div class="absolute inset-0 bg-primary/10 rounded-full blur-xl scale-150 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      <div class="relative w-20 h-20 flex items-center justify-center bg-gray-50 dark:bg-muted/30 rounded-[24px] border border-gray-100 dark:border-border shadow-sm">
        <slot name="icon">
          <component 
            :is="iconComponent" 
            v-if="iconComponent"
            class="w-10 h-10 text-gray-400 dark:text-gray-500" 
            stroke-width="1.5"
          />
          <svg 
            v-else
            class="w-10 h-10 text-gray-400 dark:text-gray-500" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
          </svg>
        </slot>
      </div>
    </div>

    <!-- Text Content -->
    <h3 class="text-xl md:text-2xl font-semibold text-gray-900 dark:text-white mb-2">
      {{ title }}
    </h3>
    <p class="text-sm md:text-base text-gray-500 dark:text-gray-400 max-w-sm mb-8">
      {{ description }}
    </p>

    <!-- Action Slot -->
    <div v-if="$slots.action" class="flex flex-col sm:flex-row gap-3">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    iconComponent: {
      type: [Object, Function],
      default: null
    }
  }
};
</script>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
